export const CommentSecond = ({ width = 30, height = 30 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill="white" />
      <g clipPath="url(#clip0_19_10636)">
        <path
          d="M12.2696 19.8L15.0008 22.5312L17.732 19.8H20.6008C21.4832 19.8 22.2008 19.0824 22.2008 18.2V8.6C22.2008 7.7176 21.4832 7 20.6008 7H9.40078C8.51838 7 7.80078 7.7176 7.80078 8.6V18.2C7.80078 19.0824 8.51838 19.8 9.40078 19.8H12.2696ZM9.40078 8.6H20.6008V18.2H17.0696L15.0008 20.2688L12.932 18.2H9.40078V8.6Z"
          fill="#121212"
        />
        <path
          d="M15.3839 11.1752L11.4023 15.1504V16.5896H12.8423L16.8223 12.6144L15.3839 11.1752ZM17.1591 9.39917L18.5991 10.8392L17.5031 11.9352L16.0631 10.496L17.1591 9.39917Z"
          fill="#121212"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_10636">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(7 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
